import _definePage_default_0 from '/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/access-control.vue?definePage&vue'
import _definePage_default_3 from '/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/login.vue?definePage&vue'
import _definePage_default_4 from '/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/not-authorized.vue?definePage&vue'
import _definePage_default_5 from '/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/responsaveis-assinatura/Index.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/access-control.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/fichas-epi',
    /* internal name: 'fichas-epi' */
    /* no component */
    children: [
      {
        path: 'Create',
        name: 'fichas-epi-create',
        component: () => import('/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/fichas-epi/Create.vue'),
        /* no children */
      },
      {
        path: 'details',
        name: 'fichas-epi-details',
        component: () => import('/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/fichas-epi/details.vue'),
        /* no children */
      },
      {
        path: 'Index',
        name: 'fichas-epi-index',
        component: () => import('/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/fichas-epi/Index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/home.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/login.vue'),
    /* no children */
  },
  _definePage_default_3
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_4
  ),
  {
    path: '/responsaveis-assinatura',
    /* internal name: 'responsaveis-assinatura' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'Index',
        name: 'responsaveis-assinatura-index',
        component: () => import('/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/responsaveis-assinatura/Index.vue'),
        /* no children */
      },
  _definePage_default_5
  )
    ],
  },
  {
    path: '/romaneio-entrega',
    /* internal name: 'romaneio-entrega' */
    /* no component */
    children: [
      {
        path: 'Index',
        name: 'romaneio-entrega-index',
        component: () => import('/home/app-me-infotech/htdocs/me.infotech.app.br/resources/js/pages/romaneio-entrega/Index.vue'),
        /* no children */
      }
    ],
  }
]
